import React, { useState } from 'react';
import '@ui5/webcomponents-icons/dist/overflow';
import { Button, ButtonPropTypes, Popover } from '@ui5/webcomponents-react';
import { useStyles } from './OverflowMenu.jss';
import { createPortal } from 'react-dom';

import ButtonDesign from '@ui5/webcomponents/dist/types/ButtonDesign.js';
import PopoverPlacementType from '@ui5/webcomponents/dist/types/PopoverPlacement.js';

export interface OverflowMenuProps extends ButtonPropTypes {
  children: React.ReactNode;
}

export const OverflowMenu: React.FC<OverflowMenuProps> = ({ children, ...props }) => {
  const [isMenuOpen, setMenuOpen] = useState<boolean>(false);
  const classes = useStyles();

  return (
    <>
      <Button
        {...props}
        id={props.id || 'overflow-button'}
        icon="overflow"
        design={ButtonDesign.Transparent}
        onClick={() => setMenuOpen(isMenuOpen ? false : true)}
      />
      {isMenuOpen &&
        createPortal(
          <Popover
            opener={props.id || 'overflow-button'}
            open={isMenuOpen}
            onBeforeClose={() => setMenuOpen(false)}
            hideArrow
            allowTargetOverlap
            placement={PopoverPlacementType.Bottom}
            className={classes.popover}
            data-testid="overflow-menu-popover"
          >
            {children}
          </Popover>,
          document.body
        )}
    </>
  );
};
